"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolanaSignMessage = void 0;
/** Name of the feature. */
exports.SolanaSignMessage = 'solana:signMessage';
//# sourceMappingURL=signMessage.js.map